<script>
import withBreakpoint from './breakpoints/with-breakpoint';

import { 
    createMap, 
    createMarker, 
    fitMapBounds, 
    createInfoWindow
 } from '../utils/mapUtils';

export default {
    mixins: [withBreakpoint],
    props: {
        lot: {
            type: Object,
            required: true
        },
        lotmap: {
            type: Object,
            required: true
        },
        zoomLevel: {
            type: Number,
            default: 2,
        }
    },
    data() {
        return {
            gm: undefined,
            map: undefined,
            latLngBounds: undefined,
            zoomListener: undefined,
            dragListener: undefined,
            isUserControlledZoom: true,
            markers: [],
            config: {
                layerId: 'my_custom_layer',
                map: {
                    fullscreenControl: false,
                    zoomControlOptions: {}
                }
            },
            icon: {
                url: `/images/site/maps/casa-pin-with-text.svg`,
                scaledSize: null,
                anchor: null,
                labelOrigin: null
            },
            label: {
                text: 'This home is located here.',
                fontFamily: 'Proxima Nova Regular, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Ubuntu, Helvetia Neue, Oxygen, Cantarell, sans-serif',
                fontSize: '16px',
                color: '#FFFFFF',
                background: '#D2732D',
            }
        }
    },
    computed: {
        boundaryLots() {
            return this.lotmap.lots.filter((l) => l.status === 'boundary')
        },
        //currentBreakpoint() { return this.$parent.currentBreakpoint || 'none'; }
    },
    watch: {
        currentBreakpoint(breakpoint) {
            if (this.map) {
                if (this.currentBreakpoint === 'phone') {
                    console.log('setting zoom to 1');
                    this.map.setOptions({ minZoom: 1, maxZoom: 4 });
                    this.map.setZoom(1);
                } else {
                    this.map.setOptions({ minZoom: 2, maxZoom: 4 });
                    this.map.setZoom(2);
                }
            }
        }
    },
    mounted() {
        events.$on("map-intialized", (map) => {
                this.initMap(map);
        });
    },
    methods: {
        async initMap() {
            // const [mapsLib, markerLib] = await Promise.all([
            //     google.maps.importLibrary('maps'),
            //     google.maps.importLibrary('marker')
            // ]);
            // homeLotMap

            // this.map = new google.maps.Map(document.getElementById(this.mapId), {
            //     mapId: 'YOUR_MAP_ID',
            //     zoom: 1,
            //     center: { lat: 0, lng: 0 },
            //     streetViewControl: false,
            //     mapTypeControl: true
            // });

            this.gm = google.maps;
            this.map = await createMap('homeLotMap', {
                center: {lat: 0, lng: 0},
                zoom: 2,
                streetViewControl: false,
                mapTypeControl: false,
            });
        
            this.infoWindow = createInfoWindow({});

            if (this.lotmap) {
                const layer = new google.maps.ImageMapType({
                    name: this.config.layerId,
                    getTileUrl: (coord, zoom) => this.lotmap.tiles_path
                        .replace('{x}', coord.x)
                        .replace('{y}', coord.y)
                        .replace('{z}', zoom),
                    tileSize: new google.maps.Size(256, 256),
                    minZoom: 0,
                    maxZoom: 4
                });

                this.map.mapTypes.set(this.config.layerId, layer);
                this.map.setMapTypeId(this.config.layerId);
                
                await this.generateMarker();
                this.boundaryLots.forEach(this.generateBoundary);
                this.initListeners();
            }
        },
        initListeners() {
            this.latLngBounds = new google.maps.LatLngBounds(
                {lat: -60, lng: -22.5},
                {lat: 60, lng: 22.5}
            );

            this.map.addListener('dragend', this.handleDrag);
        },
        handleDrag() {
             const center = this.map.getCenter();
              console.log("handle drag", this.gm, !this.latLngBounds.contains(center));
            // If out of bounds, move the map back within bounds
            if (this.gm && !this.latLngBounds.contains(center)) {
                const maxX = this.latLngBounds.getNorthEast().lng();
                const maxY = this.latLngBounds.getNorthEast().lat();
                const minX = this.latLngBounds.getSouthWest().lng(); 
                const minY = this.latLngBounds.getSouthWest().lat();
                let x = center.lng();
                let y = center.lat();
                if (x < minX) {
                    x = minX;
                }
                if (x > maxX) {
                    x = maxX;
                }
                if (y < minY) {
                    y = minY;
                }
                if (y > maxY) {
                    y = maxY;
                }
                this.map.setCenter(new google.maps.LatLng(x, y));
            }
        },
       async generateMarker() {
            // const marker = new google.maps.Marker({
            //     map: this.map,
            //     position: {
            //         lat: parseFloat(this.lot.latitude),
            //         lng: parseFloat(this.lot.longitude),
            //     },
            //     icon: {
            //         ...this.icon,
            //         // url: `images/site/maps/marker-${item.status}.png`,
            //     },
            //     label: {
            //         // ...this.label,
            //         //text: this.lot.home_lot,
            //         // text: ''
            //     },
            // });
            const marker = await createMarker({
                map: this.map,
                position: {
                    lat: parseFloat(this.lot.latitude),
                    lng: parseFloat(this.lot.longitude)
                },
                icon: this.icon.url,
                title: this.lot.marker_label,
                className: 'custom-marker',
                size: { width: 150, height: 75 },
                id: `marker_${this.lot.id}`, 
                usePin: false,
            });

            this.markers.push(marker);
        },
       async generateBoundary(boundary) {
            // const marker = new google.maps.Marker({
            //     map: this.map,
            //     position: {
            //         lat: parseFloat(boundary.latitude),
            //         lng: parseFloat(boundary.longitude),
            //     },
            //     visible: false,
            // })

            const marker = await createMarker({
                map: this.map,
                position: {
                    lat: parseFloat(boundary.latitude),
                    lng: parseFloat(boundary.longitude)
                },
                icon: this.icon.url,
                title: '',
                className: 'custom-marker',
                size: { width: 80, height: 80 },
                id: `marker_${boundary.id}`, 
                usePin: false,
            });

            this.markers.push(marker);
        },
    }
}
</script>

<style>
    #homeLotMap {
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// resources/components/apps/home-lot-map.vue